var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAviva(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 2500,
    height: 2500,
    viewBox: "0 0 192.756 192.756",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fillRule: "evenodd",
    clipRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    fillOpacity: 0,
    d: "M0 0h192.756v192.756H0V0z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#1e71b8",
    d: "M172.986 116.695v-3.797h-1.351v-.589h3.59v.589h-1.354v3.797h-.885zM181.074 116.695h-.883v-3.422h-.012c-.482 1.221-.984 2.324-1.479 3.422h-.477c-.471-1.098-.945-2.201-1.402-3.422h-.014v3.422h-.707v-4.387h1.09c.451 1.078 1.178 2.793 1.348 3.357h.012c.207-.588.994-2.279 1.498-3.357h1.025v4.387h.001zM89.551 124.846c.735.131 3.375.902 3.375 2.775v30.037h8.929v-33.883H89.551v1.071zM19.342 123.775v1.07c1.083.225 3.427.879 2.477 2.994L8.504 157.658h7.035l4.169-9.295h14.75l3.645 9.295h9.251L34.14 123.775H19.342zm2.254 20.379l5.983-13.33 5.226 13.33H21.596zM156.236 123.775v1.07c1.078.225 3.428.879 2.475 2.994l-13.312 29.818h7.037l4.162-9.295h14.75l3.648 9.295h9.256l-13.221-33.883h-14.795v.001zm2.254 20.379l5.982-13.33 5.227 13.33H158.49zM132.484 157.658l14.119-33.883h-6.678l-10.355 24.846-9.852-24.846h-12.547v1.07c1.449.277 3.076.902 3.818 2.775l11.91 30.037h9.585v.001zM70.594 157.658l14.123-33.883h-6.681l-10.353 24.846-9.855-24.846H45.282v1.07c1.452.277 3.074.902 3.82 2.775l11.904 30.037h9.588v.001z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M119.854 96.183l-5.93-61.077h-.004l-6.02 62.093c3.899-.429 7.887-.769 11.954-1.016z",
    fill: "#f6d330"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M134.357 95.739l.02-60.633-20.453-.008v.008l5.93 61.077c4.736-.279 9.572-.435 14.503-.444z",
    fill: "#82ba5d"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M107.9 97.199l6.02-62.093v-.008l-53.477.008.027 73.728c12.565-5.492 28.921-9.584 47.43-11.635z",
    fill: "#1e71b8"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAviva);
export default __webpack_public_path__ + "static/media/aviva.8fbbfcaae81ce299d17fb0d4cb8a296b.svg";
export { ForwardRef as ReactComponent };